module.exports = __webpack_public_path__ + "static/media/3DPPA43.61c55c86.jpg";